module.exports = __webpack_public_path__ + "static/CFG_Artist_LittleTokyo-1689a418f149c1d27c311621b8191039.jpg";